// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__1s2gX","clinicsSelect":"styles_clinicsSelect__1uJdh"};